import { isoToTimezoneDateTime } from '../../utils';
import { formatSlotTime, weekMonday, weeksBetweenMondays } from './datetime.util';


export const mapPatientAppointmentsByWeek = (
  appointments: PatientAppointmentSource[],
  anchorISO: string,
  weekCount: number,
  timezone?: string,
): Map<number, PatientWeekAppointment[]> => {
  const byWeek = new Map<number, PatientWeekAppointment[]>();
  if (weekCount <= 0) return byWeek;

  const intakeMonday = weekMonday(isoToTimezoneDateTime(anchorISO, timezone));

  for (const appt of appointments) {
    const start = isoToTimezoneDateTime(appt.appointmentStartDateTime, timezone);
    const weekIndex = weeksBetweenMondays(intakeMonday, weekMonday(start));
    if (weekIndex < 0 || weekIndex >= weekCount) continue;
    const list = byWeek.get(weekIndex) ?? [];
    list.push({
      appointmentExternalId: appt.appointmentExternalId,
      title: appt.appointmentTypeLabel,
      startTime: appt.appointmentStartDateTime,
      endTime: appt.appointmentEndDateTime,
      hostFirstName: appt.host?.firstName,
      hostLastName: appt.host?.lastName,
      hostAvatarUrl: appt.host?.avatar?.url,
      weekIndex,
    });
    byWeek.set(weekIndex, list);
  }

  for (const list of byWeek.values()) {
    list.sort(
      (a, b) =>
        new Date(a.startTime).getTime() - new Date(b.startTime).getTime(),
    );
  }
  return byWeek;
};

export const mapBookedFollowUps = (
  appointments: BookedAppointmentSource[],
  hostId: string,
  anchorISO: string,
  weekCount: number,
  timezone?: string,
): Map<number, BookedFollowUp> => {
  const byWeek = new Map<number, BookedFollowUp>();
  if (!hostId || weekCount <= 0) return byWeek;

  const intakeMonday = weekMonday(isoToTimezoneDateTime(anchorISO, timezone));

  for (const appt of appointments) {
    if (appt.host?.externalId !== hostId) continue;
    const start = isoToTimezoneDateTime(appt.appointmentStartDateTime, timezone);
    const weekIndex = weeksBetweenMondays(intakeMonday, weekMonday(start));
    if (weekIndex < 0 || weekIndex >= weekCount) continue;
    if (byWeek.has(weekIndex)) continue;
    byWeek.set(weekIndex, {
      appointmentExternalId: appt.appointmentExternalId,
      startTime: appt.appointmentStartDateTime,
      endTime: appt.appointmentEndDateTime,
      formattedStartEndTime: formatSlotTime(
        appt.appointmentStartDateTime,
        appt.appointmentEndDateTime,
        timezone,
      ),
      weekIndex,
    });
  }
  return byWeek;
};
